import { QueryClient } from "@tanstack/vue-query"
import { ApiError } from "@/api"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (
          error instanceof ApiError &&
          error.status === 408
        ) {
          return false
        }

        // This retries up to 3 times
        return failureCount < 2
      },
    },
  },
})
